module.exports = __webpack_public_path__ + "static/img/comsoft-graphics-1.3a52be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/comsoft-graphics-1.png
// module id = 7g2o
// module chunks = 1